/* PDP trust chips (disclaimers Tier 1) — each chip opens a
   notification-overlay sheet (bottom sheet on mobile, modal on desktop).
   Loaded by main-product.liquid alongside notification-overlay.js when the
   disclaimer-chips block is present. */
(function () {
  if (customElements.get('pdp-trust-chips')) return;

  class PdpTrustChips extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (evt) => {
        const chip = evt.target.closest('.trust-chip');
        if (!chip || !window.notificationOverlay) return;
        window.notificationOverlay.show({
          title: chip.dataset.sheetTitle,
          message: chip.dataset.sheetMessage,
          actions: [{ text: 'OK', type: 'primary' }]
        });
      });
    }
  }

  customElements.define('pdp-trust-chips', PdpTrustChips);
})();
